import { createContext, useEffect, useState } from "react";
import { request } from "./request";
import { convertToApproximateString } from "./Components/App/Inputs/convert";
import { load } from "cheerio";
import axios from "axios";
import { texts } from "./texts";

export const MainContext = createContext();

const isValidJSON = (json) => {
    try {
        if (!json) return false;
        JSON.parse(json);
        return true;
    } catch {
        return false;
    }
};

export const MainContextProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem("token"));
    const [language, setLanguage] = useState("en");
    const [capital, setCapital] = useState({ capital: 0, allAmount: [] });
    const [openState, setOpenState] = useState({
        addAccount: false,
        addTransaction: false,
        addCustomer: false,
        addAutomation: false,
        addUser: false,
        history: false,
    });
    const [isOpen, setIsOpen] = useState();
    const [showGif, setShowGif] = useState(true);
    const [darkMode, setDarkMode] = useState(true);
    const [accounts, setAccounts] = useState([]);
    const [inactiveAccounts, setInactiveAccounts] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [customerType, setCustomerType] = useState([]);
    const [users, setUsers] = useState([]);
    const [all_currencies, setAllCurrencies] = useState([]);
    const [premissions, setPremissions] = useState(isValidJSON(window.localStorage.getItem("premissions")) ? JSON.parse(window.localStorage.getItem("premissions")) : {});
    const [transactions, setTransactions] = useState([]);
    const [joinedTransactions, setJoinedTransactions] = useState([]);
    const [boundableTransactions, setBoundableTransactions] = useState([]);
    const [accountTypes, setAccountTypes] = useState([]);
    const [optionGroups, setOptionGroups] = useState([]);

    const [exchangeRates, setExchangeRates] = useState({});

    const switchLanguage = (lang) => {
        setLanguage(lang);
    };

    const flattenTexts = () => {
        const newObj = { ...JSON.parse(JSON.stringify(texts)) };
        Object.entries(texts).map(([key, value]) => {
            Object.entries(value).map(([key1, value1]) => {
                newObj[key][key1] = value1[language];
            });
        });
        return newObj;
    };

    useEffect(() => {
        request.get("/sas/").then(({ data }) => {
            setExchangeRates(data);
        });
    }, []);

    const updateToken = (newToken) => {
        localStorage.setItem("token", newToken);
        setToken(newToken);
    };

    const boxOpener = (name) => {
        setOpenState((prev) => ({
            ...prev,
            [name]: !prev[name],
        }));
    };

    const updateCapital = () => {
        if (!token) return;
        if (!premissions.account?.capital) return;
        request
            .get("/history/capital")
            .then((res) => {
                setCapital({
                    capital: convertToApproximateString(parseInt(res.data?.capital)),
                    allAmount: res.data?.allAmount.map((e) => ({ ...e, value: convertToApproximateString(e.value) })),
                });
            })
            .catch((err) => console.log(err));
    };

    const updateUsers = () => {
        if (!token) return;
        request
            .get("/user/")
            .then((res) => {
                setUsers(res.data);
            })
            .catch((err) => console.log(err));
    };

    const updateAccounts = () => {
        if (!token) return;
        if (!premissions.account?.default) return;
        request
            .get("/account")
            .then((res) => {
                setAccounts(res.data);
            })
            .catch((err) => console.log(err));
    };

    const updateInactiveAccounts = () => {
        if (!token) return;
        if (!premissions.account?.default) return;
        request
            .get("/account/inactive")
            .then((res) => {
                setInactiveAccounts(res.data);
            })
            .catch((err) => console.log(err));
    };

    const updateCustomers = () => {
        if (!token) return;
        if (!premissions.customer?.default) return;
        request
            .get("/customer")
            .then((res) => {
                setCustomers(res.data);
            })
            .catch((err) => console.log(err));
        request
            .get("/customer/type/")
            .then((res) => {
                setCustomerType(res.data);
            })
            .catch((err) => console.log(err));
    };

    const updateAllCurrencies = () => {
        if (!token) return;
        if (!premissions.customer?.default) return;
        request
            .get("/currency")
            .then((res) => {
                setAllCurrencies(res.data.map((e) => e.name));
            })
            .catch((err) => console.log(err));
    };

    const updateAccountTypes = () => {
        if (!token) return;
        request
            .get("/account/type")
            .then((res) => {
                setAccountTypes(res.data);
            })
            .catch((err) => console.log(err));
    };

    const updateTransactions = () => {
        if (!token) return;
        if (!premissions.transaction?.default) return;
        request
            .get("/transaction/")
            .then((res) => {
                setTransactions(res.data);
            })
            .catch((err) => console.log(err));
        request
            .get("/transaction/joined/")
            .then((res) => {
                setJoinedTransactions(res.data);
            })
            .catch((err) => console.log(err));
        request
            .get("/transaction/to-be-bounded")
            .then((res) => {
                setBoundableTransactions(res.data);
            })
            .catch((err) => console.log(err));
    };

    const updateUserGroups = () => {
        request
            .get("/user/group")
            .then((res) => {
                setOptionGroups(res.data.map((e) => ({ value: e.inputs, label: e.name })));
            })
            .catch((err) => console.log(err));
    };

    const refreshData = () => {
        updateAccounts();
        updateCustomers();
        updateAllCurrencies();
        updateInactiveAccounts();
        updateCapital();
        updateUsers();
        updateTransactions();
        updateAccountTypes();
        updateUserGroups();
    };

    useEffect(() => {
        if (token) {
            request.get("/user/my-premissions").then((res) => {
                if (JSON.stringify(premissions) !== JSON.stringify(res.data)) {
                    window.localStorage.setItem("premissions", JSON.stringify(res.data));
                    setPremissions(res.data);
                }
                refreshData();
            });
        }
    }, [token, premissions]);

    console.log(optionGroups);

    return (
        <MainContext.Provider
            value={{
                premissions,
                darkMode,
                refreshData,
                setDarkMode,
                accounts,
                inactiveAccounts,
                customers,
                customerType,
                isOpen,
                all_currencies,
                token,
                capital,
                users,
                showGif,
                openState,
                transactions,
                boundableTransactions,
                joinedTransactions,
                accountTypes,
                exchangeRates,
                language,
                texts: flattenTexts(),
                switchLanguage,
                boxOpener,
                setShowGif,
                setIsOpen,
                updateAccounts,
                updateInactiveAccounts,
                updateCustomers,
                updateAllCurrencies,
                updateToken,
                updateCapital,
                updateUsers,
                setUsers,
                updateTransactions,
                updateAccountTypes,
                optionGroups,
            }}
        >
            {children}
        </MainContext.Provider>
    );
};
